import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const User = styled.section`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  word-break: keep-all;
  white-space: nowrap;

  & > div {
    display: flex;
    margin-bottom: 1.1rem;
  }

  & > .title {
    ${Typography('subtitle2').bold};
    padding: 1.8rem 0 1.7rem;
    margin-bottom: 0;
  }

  & .sub-title {
    width: 9.6rem;
    margin-right: 2rem;
    ${Typography('body1').regular};
    color: ${({ theme }) => theme.color.gray600};
  }

  & .description {
    ${Typography('body1').regular};
    color: ${({ theme }) => theme.color.gray900};
  }
`
export const Notice = styled.footer`
  padding: 2.4rem 2rem 2.4rem;
  color: ${({ theme }) => theme.color.gray600};

  & > .title {
    ${Typography('body1').bold};
    margin-bottom: 1.2rem;
  }

  & li {
    ::before {
      content: '•';
      display: inline-block;
      width: 1.5rem;
      margin-left: -1.5rem;
    }
    margin-left: 1.5rem;
    ${Typography('body2.multiline').regular};
    margin-bottom: 1rem;
  }
`

export const ItemContainer = styled.section`
  display: block;
  padding: 0 1rem;
  margin-bottom: 2rem;
`

export const CancelPolicyItemContainer = styled.section`
  display: block;
  margin-bottom: 2rem;
`

export const Title = styled.div`
  ${Typography('subtitle2').bold};
  color: ${({ theme }) => theme.color.gray900};
  padding: 1.7rem 0;
`
export const Detail = styled.div`
  display: flex;
  margin: 0 1rem 1rem;
  align-items: flex-start;
  ${Typography('body1').regular};

  & .title {
    flex: 0 1 auto;
    color: ${({ theme }) => theme.color.gray600};
    margin-right: 2rem;
    white-space: nowrap;
    min-width: 5.3rem;
  }
  & .description {
    flex: 1 1 auto;
    color: ${({ theme }) => theme.color.gray900};
    margin-right: 0.8rem;
    word-break: break-all;
    white-space: pre-wrap;
  }

  & .link {
    flex: 0 1 auto;
    white-space: nowrap;
  }

  & .subtitle {
    ${Typography('body1').bold};
    ${({ theme }) => theme.color.gray900};
    margin-bottom: 1.2rem;
  }

  & .dash {
    flex: 1;
    height: 1px;
    width: 100%;
    margin: 2.5rem 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
  }

  & .map-frame {
    position: relative;
    flex: 1;
    width: 100%;
    min-height: 15rem;
    height: 15rem;
    border-radius: 0.8rem;
    overflow: hidden;
  }

  & .address-icon {
    margin-right: 0.4rem;
    margin-top: 0.1rem;
  }

  & ul {
    margin-bottom: 1rem;
  }

  & li {
    color: ${({ theme }) => theme.color.gray600};
    margin-left: 1.5rem;
    ${Typography('body1.multiline').regular};
    margin-bottom: 1.2rem;
    ::before {
      content: '•';
      display: inline-block;
      width: 1.5rem;
      margin-left: -1.5rem;
    }
  }
`
